import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RfqQuoteComponent } from './rfq-quote/rfq-quote.component';
import { RfqRoutingModule } from './rfq-routing.module';
import { LeadManagementComponent } from './lead-management/lead-management.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { CreateRfqComponent } from './create-rfq/create-rfq.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PopupDropdownComponent } from './popup-dropdown/popup-dropdown.component';
import { MaterialDropdownComponent } from './material-dropdown/material-dropdown.component';
// import { DndDirective } from './directives/dnd.directive';
// import { SharedModule } from 'projects/common-resource';
import { IndirectMaterialComponent } from './indirect-material/indirect-material.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ElementsModule } from 'src/app/shared/elements/elements.module';
import { icons, LucideAngularModule } from 'lucide-angular';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RfqDetailComponent } from './rfq-detail/rfq-detail.component';

@NgModule({
  declarations: [
    RfqQuoteComponent,
    LeadManagementComponent,
    CreateRfqComponent,
    PopupDropdownComponent,
    MaterialDropdownComponent,
    IndirectMaterialComponent,
    RfqDetailComponent,
  ],
  imports: [
    CommonModule,
    RfqRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule,
   // SharedModule,
    ScrollingModule,
    ElementsModule,
    InfiniteScrollModule,
    LucideAngularModule.pick(icons),

  ],
})
export class RfqModule {}
